import request from '@/utils/http';

export const getDepositDetails = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/queryDeposit`,
        method: 'get',
        params
    });
};

export const getDepositRegressionDetails = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getDetailForegift`,
        method: 'get',
        params
    });
};

export const getPreservation = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/save`,
        method: 'post',
        data
    });
};

export const getRefundPreservation = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/saveDrawBack`,
        method: 'post',
        data
    });
};

// 美的付
export const getPaymentOfBeauty = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/bidPayOrder`,
        method: 'post',
        data
    });
};

// // 调用标书
export const getBidingDocument = (data) => {
    return request({
        url: `/api-bms-web/bid/bidPayAccounts`,
        method: 'post',
        data
    });
};

// 查询客户支付状态
export const getBackCode = (data) => {
    return request({
        url: `/api-bms-web/saveDrawBackCode`,
        method: 'post',
        data
    });
};
// 获取申请函PDF文件
export const getApplyLetterForPDF = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/getApplyLetterForPDF`,
        method: 'post',
        data
    });
};

// 退款函下载
export const getRefundLetter = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/getApplyFor`,
        method: 'post',
        data
    });
};

// 押金退款明细
export const getRefundDetails = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getDepositRefund`,
        method: 'get',
        params
    });
};
// 支付申请列表-提交
export const payApplySubmit = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/payApplySubmit`,
        method: 'post',
        data
    });
};
// 支付申请申请函电子签章
export const applyLetterElectronicSign = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/applyLetterElectronicSign`,
        method: 'post',
        data
    });
};
// 支付申请申请函电子签章撤回
export const applyLetterElectronicRevoke = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/applyLetterElectronicRevoke`,
        method: 'post',
        data
    });
};

export const getSaveDrawBack = (data) => {
    return request({
        url: `/api-bms-web/depositManagement/saveDrawBack`,
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data
    });
};

// 判断是否可以打开支付申请界面
export const getOrAmtData = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getOrAmt`,
        method: 'get',
        params
    });
};

// 查看附件
export const getAttachment = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/getAttachment`,
        method: 'get',
        params
    });
};

// 查看附件
export const getCancelPay = (params) => {
    return request({
        url: `/api-bms-web/depositManagement/cancelPay`,
        method: 'get',
        params
    });
};
